import { render, staticRenderFns } from "./CheckOutLandingPage.vue?vue&type=template&id=85bcc0c6&scoped=true&"
import script from "./CheckOutLandingPage.vue?vue&type=script&lang=js&"
export * from "./CheckOutLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./CheckOutLandingPage.vue?vue&type=style&index=0&id=85bcc0c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bcc0c6",
  null
  
)

export default component.exports